import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const getToDoTaskSlice = createSlice({
  name: "To Do Task",

  initialState: { toDoTaskData: [], toDoTasLoader: false },
  reducers: {
    setToDoTaskData: (state: any, action: PayloadAction<any>) => {
      state.toDoTaskData = action.payload;
    },
    setToDoTaskLoader: (state: any, action: PayloadAction<any>) => {
      state.toDoTasLoader = action.payload;
    },
    resetToDoTaskData: (state: any) => {
      state = [];
    },
  },
});

export const {  setToDoTaskData, resetToDoTaskData, setToDoTaskLoader } =
  getToDoTaskSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default getToDoTaskSlice.reducer;
